import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Navbar from "../Navbar/Navbar.jsx";
import "./homepage.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import shipimage from "../assets/shipimage.jpg";
import sliderone from "../assets/sliderone.jpg";
import slidertwo from "../assets/slidertwo.jpg";
import sliderthree from "../assets/sliderthree.jpg";
// import sliderfour from "../assets/sliderfour.jpg";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import EngineeringIcon from "@mui/icons-material/Engineering";

const servicesData = [
  {
    label: "Crew Management",
    icon: <EngineeringIcon />,
    description:
      "We specialize in providing highly qualified, STCW-compliant, and well-trained crew members for a wide variety of vessels, including tankers, container ships, bulk carriers, and offshore units. Our crew management services cover the full spectrum of recruitment, documentation, onboarding, certification verification, payroll management, and crew welfare. We ensure a seamless transition between crew rotations, reducing downtime and improving overall vessel performance.\n\n" +
      "We also offer customized training programs and workshops tailored to specific vessel types and operational demands, maintaining high standards of safety and compliance. Our global network of seafarers allows us to supply officers and ratings quickly, ensuring that our clients meet their operational timelines. We emphasize crew retention and satisfaction, helping companies maintain experienced personnel across long-term assignments. We are committed to building trust through transparency, competence, and timely support to both shipowners and crew members.",
  },
  {
    label: "Ship Management",
    icon: <DirectionsBoatIcon />,
    description:
      "Our ship management service offers comprehensive technical, operational, and safety management for all vessel types. We ensure full lifecycle support, from dry docking, class surveys, and technical maintenance to budgeting and financial reporting. Our experienced superintendents work proactively to identify maintenance needs and avoid costly repairs or downtime.\n\n" +
      "We implement a robust planned maintenance system (PMS) and adhere strictly to the International Safety Management (ISM) code and International Ship and Port Facility Security (ISPS) standards. Through consistent audits and inspections, we ensure compliance with all flag state, port state, and classification society requirements. We also handle procurement, logistics, inventory control, and cost optimization.\n\n" +
      "We understand the importance of real-time vessel performance monitoring and make use of digital tools for analytics and reporting. Our management approach is focused on reliability, efficiency, and minimizing environmental impact through compliance with MARPOL regulations. With us, shipowners can focus on commercial operations while we handle day-to-day vessel responsibilities with transparency and professionalism.",
  },
  {
    label: "Chartering /Vessel Management",
    icon: <BuildIcon />,
    description:
      "Our chartering vessel management services are designed to help shipowners and operators maximize revenue through optimized vessel utilization. We facilitate both time and voyage charters for all vessel types, handling everything from commercial negotiations to fixture execution. Our team has a deep understanding of the shipping market, trade lanes, and freight rate dynamics, allowing us to secure favorable contracts for our clients.\n\n" +
      "We assist in drafting and reviewing charter parties, handling post-fixture operations, laytime calculations, demurrage/despatch, and performance monitoring. Additionally, we maintain strong relationships with brokers, charterers, and logistics firms globally, ensuring continuous opportunities for vessel deployment. We keep our clients informed with up-to-date market intelligence and forecasts, enabling data-driven decision-making.\n\n" +
      "Our chartering team also supports voyage planning, bunker procurement, and risk mitigation to ensure cost-effective and timely voyages. We help reduce idle time, avoid off-hire issues, and maximize voyage profitability. Whether it’s spot charters or long-term contracts, we ensure every aspect of the chartering process is handled with precision and professionalism, making us a trusted partner for global maritime commercial operations.",
  },
];


const HomePage = () => {
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    const handleHashChange = () => {
      const id = window.location.hash.replace("#", "");
      if (id) {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <div>
      <Navbar />

      <div className="sliderContainer">
  <Slider {...settings}>
    {[shipimage, sliderone, slidertwo, sliderthree].map((img, index) => (
      <div key={index} className="slideWrapper">
        <img src={img} alt={`Slide ${index + 1}`} className="sliderImage" />
        <div className="slideText">BridgeviewShips</div>
      </div>
    ))}
  </Slider>
</div>


      {/* <div id="about" className="about-section">
        <h2>About Us</h2>
        <p>
          The Company provides high quality and dependable Technical Consultancy
          and Human Resource services in Commercial Ship management, Offshore-
          Oil & Gas and Shipbuilding industry. Our focus is on main fleet as
          well offshore fleet for Technical management /Crew Management. We
          have a wide selection of the finest personnel for various types of
          vessels (Tankers, Chemical Tanker, Gas carrier, FPSO, FSU, Offshore,
          Bulk Carrier, Containers, Car Carriers and Log Carriers and General
          Cargo) readily available upon request who are best known in the
          maritime industry for their professionalism, efficiency and
          reliability. We also provide competent manpower to the Shipbuilding &
          Offshore Construction Industries.
        </p>
      </div> */}
       <Box id="services" sx={{ padding: 4, backgroundColor: "#fff" }}>
      <Typography variant="h4" gutterBottom>
        Our Services
      </Typography>
      <Paper elevation={3} sx={{ padding: 2 }}>
        <Tabs
          value={value}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          indicatorColor="primary"
          textColor="primary"
        >
          {servicesData.map((service, index) => (
            <Tab
              key={service.label}
              label={service.label}
              icon={service.icon}
              iconPosition="start"
              sx={{ textTransform: "none", fontWeight: "bold" }}
            />
          ))}
        </Tabs>
        <Box sx={{ padding: 3 }}>
          <Typography variant="body1" color="text.secondary">
            {servicesData[value].description}
          </Typography>
        </Box>
      </Paper>
    </Box>
      <div id="contact" className="contact-section">
        <h2>Contact Us</h2>
        <p>Have questions? Feel free to reach out to us at:</p>
        <p><strong>Email:</strong> admin@bridgeviewships.ae</p>
        <p><strong>Phone:</strong> +971 554168425</p>
        <p><strong>Address:</strong> 209, Arzu Building AI Qusais, Dubai, UAE.</p>
      </div>

      <footer className="footer">
        <p>&copy; 2025 Bridgeviewship. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;
